export const StockActionTypes = {
    STOCK_DATA_FIRST: '@@stock/STOCK_DATA_FIRST',
    STOCK_DATA_LOADING: '@@stock/STOCK_DATA_LOADING',
    STOCK_DATA_SUCCESS: '@@stock/STOCK_DATA_SUCCESS',
    STOCK_DATA_ERROR: '@@stock/STOCK_DATA_ERROR',

    CREATE_STOCK_DATA_FIRST: '@@stock/CREATE_STOCK_DATA_FIRST',
    CREATE_STOCK_DATA_LOADING: '@@stock/CREATE_STOCK_DATA_LOADING',
    CREATE_STOCK_DATA_SUCCESS: '@@stock/CREATE_STOCK_DATA_SUCCESS',
    CREATE_STOCK_DATA_ERROR: '@@stock/CREATE_STOCK_DATA_ERROR',

    UPDATE_STOCK_DATA_FIRST: '@@stock/UPDATE_STOCK_DATA_FIRST',
    UPDATE_STOCK_DATA_LOADING: '@@stock/UPDATE_STOCK_DATA_LOADING',
    UPDATE_STOCK_DATA_SUCCESS: '@@stock/UPDATE_STOCK_DATA_SUCCESS',
    UPDATE_STOCK_DATA_ERROR: '@@stock/UPDATE_STOCK_DATA_ERROR',

    DELETE_STOCK_DATA_FIRST: '@@stock/DELETE_STOCK_DATA_FIRST',
    DELETE_STOCK_DATA_LOADING: '@@stock/DELETE_STOCK_DATA_LOADING',
    DELETE_STOCK_DATA_SUCCESS: '@@stock/DELETE_STOCK_DATA_SUCCESS',
    DELETE_STOCK_DATA_ERROR: '@@stock/DELETE_STOCK_DATA_ERROR',

    UPLOAD_STOCK_DATA_FIRST: '@@stock/UPLOAD_STOCK_DATA_FIRST',
    UPLOAD_STOCK_DATA_LOADING: '@@stock/UPLOAD_STOCK_DATA_LOADING',
    UPLOAD_STOCK_DATA_SUCCESS: '@@stock/UPLOAD_STOCK_DATA_SUCCESS',
    UPLOAD_STOCK_DATA_ERROR: '@@stock/UPLOAD_STOCK_DATA_ERROR',

    FIND_TAG_IN_STOCK_FIRST: '@@stock/FIND_TAG_IN_STOCK_FIRST',
    FIND_TAG_IN_STOCK_LOADING: '@@stock/FIND_TAG_IN_STOCK_LOADING',
    FIND_TAG_IN_STOCK_SUCCESS: '@@stock/FIND_TAG_IN_STOCK_SUCCESS',
    FIND_TAG_IN_STOCK_ERROR: '@@stock/FIND_TAG_IN_STOCK_ERROR',

    STATE_EMPTY_FIRST: '@@stock/STATE_EMPTY_FIRST',
};
